import React, { useMemo, useState, useCallback } from "react";
import { keyBy } from "lodash";
import { Box, H2, P } from "orcs-design-system";

import {
  useGroupTypes,
  useAllocationConfig,
} from "src/contexts/global/WorkspaceContext";
import { getSupplyGroupTypes } from "src/util/customerConfig";
import GroupsSearch from "src/components/GroupsSearch";
import ErrorNotification from "src/components/ErrorNotification";

import { types, getConfigForChart } from "./config";
import Chart from "./Chart";
import { useChartData } from "./useChartData";

const CapacityDemandChart = () => {
  const groupTypes = useGroupTypes();
  const { demandLabel, supplyLabel } = useAllocationConfig();
  const [supplyGroup, setSupplyGroup] = useState(null);

  const { chartData, loading, error } = useChartData(supplyGroup, groupTypes);

  const dataTypes = useMemo(
    () => getConfigForChart(demandLabel, supplyLabel),
    [demandLabel, supplyLabel]
  );

  const supplyGroupTypes = useMemo(() => {
    return keyBy(getSupplyGroupTypes(groupTypes), "id");
  }, [groupTypes]);

  const handleOnGroupSelected = useCallback(
    (group) => {
      if (!supplyGroupTypes[group?.type]) {
        return;
      }
      setSupplyGroup(group);
    },
    [supplyGroupTypes]
  );

  return (
    <Box
      borderRadius={2}
      boxBorder="default"
      p="r"
      borderColor="black10"
      maxWidth="50%"
    >
      <Box p="r">
        <H2>Capacity vs Demand</H2>
        <P color="greyDark" fontSize="1.7rem" mt="r">
          {`Select a Supply group (${supplyLabel} etc.)`}
        </P>
      </Box>
      <Box p="r">
        <GroupsSearch
          placeholder="Click to search and select a team"
          actionLabel="Click to select"
          groupTypes={groupTypes}
          targetGroupTypes={supplyGroupTypes}
          onGroupSelected={handleOnGroupSelected}
        />
      </Box>
      <Box p="r">
        <Chart
          data={chartData}
          types={types}
          dataTypes={dataTypes}
          loading={loading}
        />
      </Box>
      {error && <ErrorNotification message={error?.message} error={error} />}
    </Box>
  );
};

export default CapacityDemandChart;
